import {
  CreateProjectEntity,
  TriggerPdfGenerationParams,
  ProjectParams,
} from '@/types';
import APIService from './axios.service';
import { BaseService } from './base.service';
import { IAddressDto, ProjectEntity } from '@/interfaces';
import { CustomResponse } from './type';
import { QueryFunctionContext } from '@tanstack/react-query';
import { newQueryKeys } from '@/queries/queryKeys';
import { streamQuantityEventName } from '@/components/commonComponents/ExportByColumnModal';

class ProjectService extends BaseService<
  'project',
  ProjectEntity,
  CreateProjectEntity
> {
  constructor() {
    super('projects'); //path
  }

  getProjectsWithRelations = (
    context: QueryFunctionContext<
      ReturnType<(typeof newQueryKeys)['project']['list']>
    >,
  ): Promise<CustomResponse<ProjectEntity[]>> => {
    const { params } = context.queryKey[0];

    return APIService.get(this.path + '/with-relations', { params });
  };

  getStreamExportProjects = (params: ProjectParams): Promise<any> => {
    return APIService.get(this.path + '/stream', {
      params,
      responseType: 'stream',
      onDownloadProgress(data) {
        const responseData = data.event?.target?.response || '';
        // Regex to find all progress values
        const regex = /"progress"\s*:\s*(\d+(\.\d+)?)/g;
        const matches = [...responseData.matchAll(regex)];
        // Get the last match
        const lastMatch = matches[matches.length - 1];
        const lastProgress = lastMatch
          ? Math.round(parseFloat(lastMatch[1]))
          : 0;

        // Dispatch kit quantity for percent progress bar
        window.dispatchEvent(
          new CustomEvent(streamQuantityEventName, {
            detail: { percentProgress: lastProgress },
          }),
        );
      },
    });
  };

  getAddressById = (
    context: QueryFunctionContext<
      ReturnType<(typeof newQueryKeys)['project']['detail']>
    >,
  ): Promise<IAddressDto> => {
    const { id } = context.queryKey[0];
    return APIService.get(`${this.path}/${id}/address`);
  };

  generatePdf(payload: TriggerPdfGenerationParams): Promise<any> {
    return APIService.post('/projects/regenerate-pdf', payload);
  }
}
export const projectService = new ProjectService();
